import { injectGlobal } from 'styled-components'

import BasisBold from './basis-grotesque-bold-pro.otf'
import Basis from './basis-grotesque-regular-pro.otf'
import Chap from './Chap-regular.otf'

export default injectGlobal`
    @font-face {
    font-family: 'Basis';
    src: url(${Basis}) format('opentype');
    }
    
      @font-face {
    font-family: 'Basis Bold';
    src: url(${BasisBold}) format('opentype');
    }

     @font-face {
        font-family: 'Chap';
        src: url(${Chap}) format('opentype');
    } 
`
